import { MediaResolver, ResolvedMedia, ResolverContext } from '../types';
import {
  buildEmbedResolvedMedia,
  buildFallbackEmbedUrl,
  parseRedditPostPath,
  resolveRedditMedia,
} from '../utils/parseOEmbedResponse';

export class OEmbedResolver implements MediaResolver {
  name = 'OEmbedResolver';

  async canResolve(context: ResolverContext): Promise<boolean> {
    return (
      Boolean(buildFallbackEmbedUrl(context.input.url)) ||
      Boolean(parseRedditPostPath(context.input.url))
    );
  }

  async resolve(context: ResolverContext): Promise<ResolvedMedia | null> {
    if (parseRedditPostPath(context.input.url)) {
      const redditMedia = await resolveRedditMedia(context.input.url, context.input);

      if (redditMedia) {
        return redditMedia;
      }
    }

    const fallbackEmbedUrl = buildFallbackEmbedUrl(context.input.url);

    if (fallbackEmbedUrl) {
      return buildEmbedResolvedMedia(fallbackEmbedUrl, context.input.url, context.input, {
        strategy: 'fallback-embed-url',
      });
    }

    return null;
  }
}
